const i18PrefixProductEvent = '_common:entities.products.event';
const productEventCategoriesListId = {
    SPORTS: 'KZFzniwnSyZfZ7v7nE',
    CONCERTS: 'KZFzniwnSyZfZ7v7nJ',
    ARTS: 'KZFzniwnSyZfZ7v7na',
    FAMILY: 'KnvZfZ7vA1n',
    MISCEL_EVENTS: 'KZAyXgnZfZ7v7lt',
    OTHER: 'KZFzniwnSyZfZ7v7nn',
};

export default {
    TYPE: {
        EVENT: 1,
        HOTEL: 3,
        ESPORTS: 6,
    },
    TYPES: [
        {
            id: 1,
            name: 'Event',
        },
        {
            id: 6,
            name: 'Esports',
        },
        {
            id: 3,
            name: 'Hotels',
            type: 'Hotel',
        },
    ],
    EVENT: {
        CATEGORY: {
            LIST_ID: {
                SPORTS: productEventCategoriesListId.SPORTS,
                CONCERTS: productEventCategoriesListId.CONCERTS,
                ARTS: productEventCategoriesListId.ARTS,
                FAMILY: productEventCategoriesListId.FAMILY,
                MISCEL_EVENTS: productEventCategoriesListId.MISCEL_EVENTS,
                OTHER: productEventCategoriesListId.OTHER,
            },
            LIST: [
                {
                    ID: productEventCategoriesListId.SPORTS,
                    i18nKey: i18PrefixProductEvent + '.category.list.sports',
                },
                {
                    ID: productEventCategoriesListId.CONCERTS,
                    i18nKey: i18PrefixProductEvent + '.category.list.concerts',
                },
                {
                    ID: productEventCategoriesListId.ARTS,
                    i18nKey: i18PrefixProductEvent + '.category.list.arts',
                },
                {
                    ID: productEventCategoriesListId.FAMILY,
                    i18nKey: i18PrefixProductEvent + '.category.list.family',
                },
                {
                    ID: productEventCategoriesListId.MISCEL_EVENTS,
                    i18nKey: i18PrefixProductEvent + '.category.list.miscelEvents',
                },
                {
                    ID: productEventCategoriesListId.OTHER,
                    i18nKey: i18PrefixProductEvent + '.category.list.other',
                },
            ],
        },
    },
};
